import { FileAttachment } from "./fileAttachment.model";
import { SurveyStatus } from "../enums/surveyStatus.enum";
import { SampleEndPoint } from "./sample.model";

export class SampleSurvey {
    organizationLevelId?: string;
    surveyTypeId: string;
    numberOfSamplesTaken: number;
    fileAttachmentIds: string[];
    id: string;
    name: string;
    requestedById: string;
    requestedByName: string;
    surveyStatus: SurveyStatus;
    surveyCode: string;
    surveyDescription: string;
    surveyPlannedEndDate: string;
    surveyPlannedStartDate: string;
    organizationLevelName: string;
    surveyTypeName: string;
    fileAttachments: FileAttachment[];
    endPoint?: SampleEndPoint;
}
